import Container from '@/components/Container';
import Stepper from '@/components/Stepper';
import { getAuthentication } from '@/hooks/useAuthentication';
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

export function OnboardingContainer() {
  const location = useLocation();
  const authentication = getAuthentication();
  const navigate = useNavigate();

  const match = location.pathname.match(/step-(\d+)/);
  const stepNumber = match ? parseInt(match[1], 10) : 1;

  useEffect(() => {
    if (authentication?.user?.onboardHomeCompleted) {
      navigate('/');
    }
  });

  return (
    <Container className="h-screen items-center justify-center">
      <div className="col-span-12 flex flex-col items-center justify-center rounded-2xl bg-white p-8 px-4 shadow-light-purple md:col-start-3 md:col-end-11">
        <Stepper steps={5} step={stepNumber - 1} />
        <Outlet />
      </div>
    </Container>
  );
}
